module.exports = "/static/assets/c12e386b8137e71b289edca2cca5e500.png";